import {
  Box,
  Container,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";
import { ErrorOutline, HomeOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import { StandardButton } from "../components/StandardButton";

interface ErrorProps {
  navigate?: ReturnType<typeof useNavigate>;
}

export const LoadingState = () => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flex={1}
      height="100vh"
      width="100%"
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundColor: theme.palette.primary.dark,
      }}
    >
      <CircularProgress size={60} color="primary" />
    </Box>
  );
};

export const BoardNotFoundError = ({ navigate }: ErrorProps) => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: 2,
          maxWidth: 500,
          mx: "auto",
          textAlign: "center",
        }}
      >
        <ErrorOutline color="error" sx={{ fontSize: 60, mb: 2 }} />
        <Typography variant="h5" color="error" gutterBottom>
          Board not found
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Please check the link and refresh the page
        </Typography>
        {navigate && (
          <StandardButton
            onClick={() => navigate("/admin")}
            variant="contained"
            startIcon={<HomeOutlined />}
            size="large"
            sx={{ mt: 2 }}
          >
            Go Home
          </StandardButton>
        )}
      </Paper>
    </Container>
  );
};

export const GameNotFoundError = () => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: 2,
          maxWidth: 500,
          mx: "auto",
          textAlign: "center",
        }}
      >
        <ErrorOutline color="error" sx={{ fontSize: 60, mb: 2 }} />
        <Typography variant="h5" color="error" gutterBottom>
          Game not found
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Please check the link and refresh the page
        </Typography>
      </Paper>
    </Container>
  );
};

export const CurrentRoundError = () => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: 2,
          maxWidth: 500,
          mx: "auto",
          textAlign: "center",
        }}
      >
        <ErrorOutline color="error" sx={{ fontSize: 60, mb: 2 }} />
        <Typography variant="h5" color="error" gutterBottom>
          Current Round not available
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Please check with the game administrator
        </Typography>
      </Paper>
    </Container>
  );
};
